const colors = {
  background: '#00364B',
  lightBackground: '#F2F2F7',
  silver: '#f6f6f6',
  transparent: 'rgba(0,0,0,0)',
  clear: 'rgba(0,0,0,0)',
  snow: '#FFFFFF',
  frost: '#F0F2F3',
  porcelain: '#E0E6E9',
  geyser: '#CCD4D9',
  towerGray: '#ABB9BF',
  submarine: '#8999A1',
  blueBayoux: '#67757B',
  fiord: '#515F65',
  tundora: '#4d4d4d',
  gunMetal: '#31393C',
  outerSpace: '#293032',
  cinder: '#1D2224',
  black: '#000000',
  mist: 'rgba(255,255,255, 0.88)',
  ricePaper: 'rgba(255,255,255, 0.65)',
  cloud: 'rgba(171, 185, 191, 0.35)',
  windowTint: 'rgba(81, 95, 101, 0.4)',
  dim: 'rgba(29, 34, 36, 0.3)',
  shade: 'rgba(29, 34, 36, 0.7)',
  drawer: 'rgba(29, 34, 36, 0.9)',
  moonStoneBlue: '#6CA3BA',
  scooter: '#2F86A4',
  persianBlue: '#00698F',
  blueLagoon: '#005878',
  sherpaBlue: '#00364B',
  lightSeaGreen: '#1CC09E',
  turquoise: '#60E4C9',
  skyBlue: '#2B95D7',
  border: '#CCD4D9',
  text: '#31393C',
  error: '#CB0202',
  warning: 'rgba(200, 0, 0, 0.8)',
  success: 'rgba(200, 0, 0, 0.8)',
  info: 'rgba(200, 0, 0, 0.8)',
  facebook: '#3b5998',
  faintNavy: '#E4E4F6',
  darkNavy: '#41486A',
  darkerNavy: '#121A45',

  fontDefaultColor: '#262626',
  inputColour: 'rgba(0,0,0,0.54)',
  headerBorder: '#E5E5EA',
  footerBackground: '#38395C',
  footerText: '#B0B0CE',
  disabledText: '#b2b2b2',
  grayContainer: '#F2F3F6',
  grayButton: '#DDDEE4',
  grayText: '#666666',
  violetContainer: '#EBEBF5',
  violetText: '#585AA8',
  purpleButton: '#585AA8',
  lightPurple: '#D7D7EA',
  brightPurple: '#7579F5',
  blueColor: '#3D3E75',
  brandMainHover: 'rgb(71, 76, 154)',
  errorMsgBG: '#FFE6E6',
  grey8: '#888888',
  grey7: '#71768F',
  greyD: '#D0D1DA',
  greyBorder: '#656586',

  brandMain: '#2E3192',
  brandPink: '#F7D9F3',
  brandGrey: '#EDEDED',
  brandDarkerGrey: '#D1D1D1',
  brandBlue: '#CFF8FF',
  brandShadow: 'rgba(105,105,105,0.75)',

  clockShadow: 'rgba(46, 49, 146, 0.2)',
  playerGrey: '#69778B',
  playerButtonBackground: 'rgba(0,0,0,0.15)',
  playerDarkBlue: '#121a45',
  guestListItemText: '#666',
  bigPlayerButton: 'rgba(0,0,0,0.3)',
  imgButtonLabelBg: '#EBEBF5',
  imgButtonLabelFg: '#585AA8',
  imgButtonHover: '#F26D20',
  imgButtonBorder: '#E7E8EC',
};

export default colors;
